import { render, staticRenderFns } from "./BannerCropModal.vue?vue&type=template&id=5283a8e4&scoped=true&"
import script from "./BannerCropModal.vue?vue&type=script&lang=ts&"
export * from "./BannerCropModal.vue?vue&type=script&lang=ts&"
import style0 from "./BannerCropModal.vue?vue&type=style&index=0&id=5283a8e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5283a8e4",
  null
  
)

export default component.exports